import React, { useState, useEffect } from 'react'
import { Label, Button } from 'semantic-ui-react'
import Avatar from '@mui/material/Avatar';
import { ResponsiveContainer, Line, XAxis, LineChart, YAxis, Tooltip } from 'recharts'
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { makeStyles } from '@mui/styles';
import logo_shield from '../../assets/logo_shield.svg'
import logo_token from '../../assets/3.svg'
import marca_x from '../../assets/marcaX.png'
import userImage from '../../assets/user.svg'
import linkedin1 from '../../assets/linkedin2.png'
import linkedin2 from '../../assets/linkedin1.png'
import './Dashboard.scss'
import { connect } from 'react-redux'
import { setNullUid } from '../../redux/actions/auth'
import { changeModeUser, getDataPreferencesFromUser, getDataProfile, getTwoLastWeeks } from '../../redux/actions/user'
import { withRouter } from 'react-router'
import { getCookiesUserDB, getDataUserDB, getShieldPointsTwoLastWeeks, getTwoLastWeeksFB, getUserPreferences } from '../../functions';
import Footer from '../../components/Footer/Footer';
import { getCookiesTotal } from '../../helpers';

const Dashboard = props => {

    const [mode, setMode] = useState('rewards')
    const [data, setData] = useState([])
    const [balance, setBalance] = useState("0,00")
    const [lastPoints, setLastPoints] = useState("0,00")
    const [cookies, setCookies] = useState(0)
    const [open, setOpen] = useState(false)
    const [dataUser, setDataUser] = useState(null)


    useEffect( () => {

        getUserPrefs()
        getUserData()
        getShieldPoints()
        getUserCookies()

    }, [])

    // Ir a edicion de perfil
    const goProfile = () => {
        props.history.push('/profile')
    }

    // Vamos al formulario de contacto
    const goToContact = () => {
        props.history.push('/contact')
    }
    
    // Obtenemos las preferencias del usuario
    const getUserPrefs = async () => {
        const response = await getUserPreferences();
        if(response && response.result) {
            if(response.result.empty) {
                props.history.push('/choose/preferences')
            }
        }
    }

    // Obtenemos la informacion del usuario
    const getUserData = async () => {
        const response = await getDataUserDB();
        if(response && response.result) {
            setDataUser(response.result)
            setMode(response.result.mode)
        }
    }

    // Get User cookies
    const getUserCookies = async () => {
        const response = await getCookiesUserDB();
        if(response && response.result) {
            const arrayData = [
                {
                    name: "Day 0",
                    cookies: 0
                }
            ]
            arrayData.push(response.result)
            
            setData(arrayData.flat())
            setCookies(getCookiesTotal(response.result))
        }
    }

    const getShieldPoints = async () => {

        const response = await getShieldPointsTwoLastWeeks();
        if(response && response.result) {    
            // Calculamos los puntos totales y el balance
            if(response.result && response.result.length > 0) {
                setLastPoints(response.result[response.result.length - 1].points)
                setBalance(response.result[response.result.length - 1].points)
            }
        }

    }    

    // Estilos de material ui
    const useStyles = makeStyles({
        root: {
            background: 'white',
            border: 0,
            borderRadius: 20,
            position: 'absolute',
            top: '25%',
            left: '20%',
            right: '20%',
            color: 'white',
            padding: ' 15px 30px',
        },
    });
    const classes = useStyles();

    return (
        <div className='dashboard'>

            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className={classes.root}>
                    <RenderModalDetail mode={mode} setOpen={setOpen} />
                </Box>
            </Modal>

            <div className='dashboard_header'>
                <div className='dashboard_header_content'>
                    <Avatar src={dataUser && dataUser.image_profile ? dataUser.image_profile : userImage} sx={{ width: 70, height: 70 }}/>

                    { dataUser ? <div className='dashboard_header_content_info'>
                        <span>{dataUser.name} {dataUser.surname}</span>
                        <button onClick={goProfile}>
                            Editar perfil
                        </button>
                    </div> : null}
                </div>
            </div>
             
            <div className='dashboard_cards'>

                {/* Balance */}
                <div className='dashboard_cards_balance'>
                    <div className='dashboard_cards_balance_content'>
                        <h2>
                            Cookies Bloqueadas
                        </h2>
                        <div className='dashboard_cards_balance_content_info'>
                            <img src={logo_shield} />
                            <div className='dashboard_cards_balance_content_info_text'>
                                { cookies ?  <h1>{cookies || '0'}</h1> : null}
                                <span>En los últimos 30 días</span>
                            </div>
                        </div>
                    </div>
                    <div className='dashboard_cards_balance_content'>
                        <h2 style={{ color: '#96d4f4' }}>
                            Tokens Acumulados
                        </h2>
                        <div className='dashboard_cards_balance_content_info'>
                            <img src={logo_token} />
                            <div className='dashboard_cards_balance_content_info_text'>
                                <h1 style={{ color: '#96d4f4' }}>00,00</h1>
                                <span style={{ color: '#96d4f4' }}>Shield Tokens</span>
                            </div>
                        </div>
                    </div>
                    <div className='dashboard_cards_balance_footer'>
                        <img src={require('../../assets/settings.png').default} width="30px" />
                        <span>
                            En poco podrás recibir tus pagos, estamos trabajando para ello 
                        </span>
                    </div>
                    
                </div>

                {/* Grafica */}
                <div className='dashboard_cards_graph'>
                    <div className='dashboard_cards_graph_options'>
                        <span>Historial de cookies</span>
                        <div className='dashboard_cards_graph_options_buttons'>
                            <button>Cookies</button>
                            <button disabled>
                            <img src={require('../../assets/settings.png').default} width="15px" />
                                Tokens
                            </button>
                        </div>
                    </div>
                    {data ? <ResponsiveContainer height={280} width='100%'>
                        <LineChart data={data} >
                            <XAxis dataKey="name" fontSize={11} />
                            <YAxis fontSize={11} />
                            <Tooltip />
                            <Line type="monotone" dataKey="cookies" stroke="#004e97" strokeWidth={2}/>                            
                        </LineChart>
                    </ResponsiveContainer> : null}
                </div>

                {/* Perfil */}
                <div className='dashboard_cards_profile'>
                    <h3>Últimas noticias</h3>
                    <div className='dashboard_cards_profile_content'>
                        <RenderItemLinkedin image={linkedin1} />
                        <RenderItemLinkedin image={linkedin2} />
                    </div>
                    <div className='dashboard_cards_profile_buttons'>
                        <button onClick={goToContact}>
                            Contacta con nosotros
                        </button>
                    </div>
                    
                </div>

            </div>
            {
                window.innerWidth < 700 ?
                <div className='dashboard_prof'>
                    <div className='dashboard_prof_content'>
                        <Avatar src={dataUser && dataUser.image_profile ? dataUser.image_profile : userImage} sx={{ width: 70, height: 70 }}/>

                        { dataUser ? <div className='dashboard_prof_content_info'>
                            <span>{dataUser.name} {dataUser.surname}</span>
                            <button onClick={goProfile}>
                                Editar perfil
                            </button>
                        </div> : null }
                    </div>
                </div> : null
            }

            <Footer />


        </div>
    )
}

function RenderItemLinkedin(props) {
    const { image } = props
    return (
        <div className='dashboard_cards_profile_content_item'>
            <img src={image} />
            <div className='dashboard_cards_profile_content_item_info'>
                <p>Shield Launches at IE</p>
                <span>
                    Lorem Ipsum is simply dummy text of the printin...
                </span>
            </div>
        </div>
    )

}

function RenderModalDetail(props) {

    const { mode, setOpen } = props;

    // Estilos de material ui
    const useStyles = makeStyles({
        cardDetails: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%'
        },
        title: {
            color: 'black',
            textAlign: 'center',
            margin: '0'
        },
        hr: {
            width: '100%',
            height: '1px',
            border: 'none',
            color: 'rgb(220, 220, 220)',
            background: 'rgb(220, 220, 220)'
        },
        details: {
            width: '100%'
        },
        h3: {
            textAlign: 'center',
            color: '#055c9d'
        },
        p: {
            color: 'black',
            textAlign: 'center'
        }
    });
    const classes = useStyles();

    return mode === 'rewards' ? (
        <div className={classes.cardDetails}>
            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <img src={marca_x} style={{ width: '20px', height: '20px', visibility: 'hidden' }} />
                <h2 className={classes.title}>¡Estás en el modo recompensas!</h2>
                <img src={marca_x} style={{ width: '20px', height: '20px' }} onClick={() => setOpen(false)} />
            </div>
            <hr className={classes.hr}/>
            <div className={classes.details}>
                <h3 className={classes.h3}>Acerca de esta función</h3>
                <p className={classes.p}>
                    Esta funcionalidad le permitirá recibir un ingreso pasivo a partir de sus datos personales. 
                    Hoy en día, los datos tienen un valor inmenso y Shield le permite quedarse con estas ganancias.
                </p>
            </div>
        </div>
    ) :
    (
        <div className={classes.cardDetails}>
            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <img src={marca_x} style={{ width: '20px', height: '20px', visibility: 'hidden' }} />
                <h2 className={classes.title}>¡Estás en el modo privacidad!</h2>
                <img src={marca_x} style={{ width: '20px', height: '20px' }} onClick={() => setOpen(false)}/>
            </div>
            <hr className={classes.hr}/>
            <div className={classes.details}>
                <h3 className={classes.h3}>Acerca de esta función</h3>
                <p className={classes.p}>
                Los navegadores de hoy en día están repletos de rastreadores que no necesita y que muchas veces no están autorizados. 
                ¡Recupere el control de su información con Shield en solamente unos clicks! 
                La extension de Shield le permite escoger qué tipo de información las empresas pueden extraer de usted.
                </p>
            </div>
        </div>
    )

}

// Redux
const mapStateToProps = state => {

    // Comprobamos si el usuario ya tiene registradas sus preferencias
    const result = state.user.result
    const authError = state.user.authError

    const points = state.user.data_points;
    const data_user = state.user.data

    return {
        result,
        authError,
        shield_points: points,
        data_user
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getDataPreferencesFromUser: () => dispatch(getDataPreferencesFromUser()),
        getTwoLastWeeks: () => dispatch(getTwoLastWeeks()),
        getDataProfile: () => dispatch(getDataProfile()),
        changeModeUser: mode => dispatch(changeModeUser(mode)),
        setNullUid: () => dispatch(setNullUid())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Dashboard))
